import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import OpenStackSVG from '../../../assets/icons/clouds/openstack.svg?raw';

export const OpenStackLogo = (props) => <CustomSVG svg={OpenStackSVG} preserveColors {...props} />;
